import script from "./OrganizationUsersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationUsersTable.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationUsersTable.vue?vue&type=style&index=0&id=a8f65e9a&scoped=true&lang=css"
script.__scopeId = "data-v-a8f65e9a"

export default script